import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { LayoutDetail } from '../../models/loyalty-layout.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class LayoutDetailService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService
  ) { }

  get(layoutId, layoutDetailId): Observable <LayoutDetail> {
    return this.http.get(this.baseUrl + '/layout/' + layoutId + '/detail/' + layoutDetailId);
  }

  list(layoutId): Observable <{data: Array<LayoutDetail>, metadata: ListMetadata }> {
    return this.http.getPaged(this.baseUrl + '/layout/' +  layoutId + '/detail/');
  }

  update(layoutId, idDetail, layoutDetail: LayoutDetail): Observable<LayoutDetail> {
    return this.http.put(this.baseUrl + '/layout/' + layoutId + '/detail/' + idDetail, layoutDetail);
  }

  create(layoutId, layoutDetail: LayoutDetail): Observable<LayoutDetail> {
    return this.http.post(this.baseUrl + '/layout/' + layoutId + '/detail/', layoutDetail);
  }

  remove(layoutId, layoutDetailId): Observable<LayoutDetail> {
    return this.http.delete(this.baseUrl + '/layout/' + layoutId + '/detail/' + layoutDetailId);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/LayoutDetailDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/layout-detail.service.ts